"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUrlExperimentOverride = void 0;
const react_1 = require("react");
const url_override_1 = require("./url-override");
const useExperiment_1 = require("./useExperiment");
function useUrlExperimentOverride(experimentId, configs) {
    const experiment = (0, useExperiment_1.useExperimentTreatment)(experimentId, configs);
    const urlOverrideConfig = (0, react_1.useMemo)(() => (0, url_override_1.getUrlOverrideConfig)(experimentId), [experimentId]);
    if (urlOverrideConfig) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return urlOverrideConfig.value.stringValue;
    }
    return experiment;
}
exports.useUrlExperimentOverride = useUrlExperimentOverride;
//# sourceMappingURL=useUrlExperimentOverride.js.map